import React from 'react';
import { Grid, Paper, Typography, Button } from '@mui/material';
import "./Styles/Body.css";
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ThumbDownAltOutlinedIcon from '@mui/icons-material/ThumbDownAltOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import channelImg from "../Assets/channel.png"

const VideoDetails = ({ video }) => {
  if (!video) return <div>Loading...</div>
  // www.youtube-nocookie.com/embed/i8eBBG46H8A
  const videoSrc = `https://www.youtube-nocookie.com/embed/${video.id.videoId}`;

  // UTC time to local time
  const formatDate = (dateString) => {

    const options = { year: "numeric", month: "long", day: "numeric" }

    return new Date(dateString).toLocaleDateString(undefined, options)
  }


  return (
    <>
      <Paper style={{ height: '75vh' }}>
        <iframe style={{ border: "none" }} height='100%' width="100%" title="Video Player" src={videoSrc} />
      </Paper>
      <Grid style={{ padding: '15px', borderBottom: '1px solid #3b3b3b' }}>
        <small><span className='channel_name'>#hashtag #static_hashtags</span></small>
        <Typography varient="subtitle1" className='video_title_main'>{video.snippet.title}</Typography>
        <Grid container>
          <Grid md={6}>
          <small className='video_title_des'>2,133,730 views - {formatDate(video.snippet.publishTime)}</small>
          </Grid>
          <Grid md={6} className='icon_row'>
           <div className='icon_div'><ThumbUpOutlinedIcon />&nbsp;<div className='video_title_des'> LIKE</div></div>
           <div className='icon_div'><ThumbDownAltOutlinedIcon />&nbsp;<div className='video_title_des'> DISLIKE</div></div>
           <div className='icon_div'><ShareOutlinedIcon />&nbsp;<div className='video_title_des'> SHARE</div></div>
          </Grid>
        </Grid>
      </Grid>
      <Grid container style={{ padding: '15px', borderBottom: '1px solid #3b3b3b' }}>
        <Grid xs={1}>
          <img src={channelImg} className='channel_logo'></img>
        </Grid>
        <Grid xs={11}>
          <Grid container>
            <Grid xs={8}>
              <Typography className='video_title_main'>{video.snippet.channelTitle}</Typography>
              <small><span className='video_title_des'>{video.snippet.channelTitle}466K subscribers</span></small>
              <br />
              <br />
              <p  className='video_title_des'>{video.snippet.description}</p>
            </Grid>
            <Grid xs={4} className='subs_btn'>
              <Button>SUBSCRIBE</Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
export default VideoDetails